export default __webpack_public_path__ + "static/media/mainmenu_wasteprocedures_gs.d5a8c282.jpg";